module.exports = __webpack_public_path__ + "static/img/1094.dcd31f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1094.jpg
// module id = 276
// module chunks = 0